import React from 'react';
import { TransitionMotion, spring } from 'react-motion';

export default function ActionButtonsSlider({width, slide, height}) {
  return (
    <TransitionMotion
      willEnter={() => ({
        opacity: 0,
        x: width,
      })}
      willLeave={() => ({
        opacity: spring(0),
        x: spring(-width),
      })}
      styles={[{
        key: slide.id,
        data: slide,
        style: {
          opacity: spring(1),
          x: spring(0),
        },
      }]}>
      {(configs) =>
        <div className="slider-container" style={{position: 'relative', overflow: 'hidden', width, height}}>
          {configs.map((config) =>
            <div className="slider-item"
              key={config.key}
              style={{
                width,
                position: 'absolute',
                opacity: config.style.opacity,
                transform: `translateX(${config.style.x}px)`,
              }}>
              {React.createElement(config.data.Component)}
            </div>
          )}
        </div>
      }
    </TransitionMotion>
  );
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/ActionButtonsSlider.js